<div id="chart" style="height: 20vh; min-height: 300px" #chartistDiv></div>
